import type { IAccountUserInterface } from './AccountUserInterface.interface';

export default class AccountUserInterface implements IAccountUserInterface {
  openDashboardOnLogin: boolean;
  confirmAutomatedNotifications: boolean;
  showAccountOnlineStatus: boolean;
  showTileLabels: boolean;
  showTileDealOwner: boolean;
  showTileDealPartner: boolean;
  showTileDealClient: boolean;
  showTileDueDate: boolean;
  showTileFinanceDueDate: boolean;
  showTileValue: boolean;

  static build = (data: IAccountUserInterface) => new AccountUserInterface(data);
  static blank = () => new AccountUserInterface();

  /**
   * Constructor
   * @param {IAccountUserInterface} data
   */
  constructor(data?: IAccountUserInterface) {
    this.openDashboardOnLogin = data?.openDashboardOnLogin === true;
    this.confirmAutomatedNotifications = data?.confirmAutomatedNotifications === true;
    this.showAccountOnlineStatus = data?.showAccountOnlineStatus === true;
    this.showTileLabels = data?.showTileLabels === true;
    this.showTileDealOwner = data?.showTileDealOwner === true;
    this.showTileDealPartner = data?.showTileDealPartner === true;
    this.showTileDealClient = data?.showTileDealClient === true;
    this.showTileDueDate = data?.showTileDueDate === true;
    this.showTileFinanceDueDate = data?.showTileFinanceDueDate === true;
    this.showTileValue = data?.showTileValue === true;
  }
}
